import React from 'react';

const UpcomingEvents = () => {
  const summitHighlights = [
    { id: 1, text: 'Ethical AI frameworks', color: '#6B73FF' },
    { id: 2, text: 'Global education strategies', color: '#6B73FF' },
    { id: 3, text: 'Sustainable AI development', color: '#FFB366' },
    { id: 4, text: 'Inclusive learning environments', color: '#FFB366' }
  ];

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.comingSoonBadge}>
            📅 Coming Soon
          </div>
          <h1 style={styles.title}>Upcoming Events</h1>
          <p style={styles.subtitle}>
            Join us for groundbreaking AI events that shape the future of education and technology
          </p>
        </div>

        {/* Featured Event Card */}
        <div style={styles.featuredCard}>
          <div style={styles.featuredHeader}>
            <div style={styles.calendarIcon}>📅</div>
            <div style={styles.featuredBadge}>Featured Event</div>
          </div>
          
          <div style={styles.featuredContent}>
            <h2 style={styles.eventTitle}>Global AI Society Conference</h2>
            <p style={styles.eventSubtitle}>Academic Odyssey: AI, Leadership & the Future of Global Education</p>
          </div>
        </div>

        {/* Event Details */}
        <div style={styles.eventDetails}>
          <p style={styles.eventDescription}>
            How do we ensure artificial intelligence education serves society—not just markets? Join global leaders in 
            shaping the future of AI education.
          </p>

          {/* Event Info Grid */}
          <div style={styles.eventInfoGrid}>
            <div style={styles.infoItem}>
              <div style={styles.infoIcon}>📅</div>
              <div>
                <div style={styles.infoTitle}>October 18-24, 2025</div>
                <div style={styles.infoSubtitle}>Seven-days intensive summit</div>
              </div>
            </div>

            <div style={styles.infoItem}>
              <div style={styles.infoIcon}>📍</div>
              <div>
                <div style={styles.infoTitle}>European Institute of Management and Technology</div>
                <div style={styles.infoSubtitle}>🇨🇭 Zurich, Switzerland</div>
              </div>
            </div>

            <div style={styles.infoItem}>
              <div style={styles.infoIcon}>👥</div>
              <div>
                <div style={styles.infoTitle}>500+ Global Leaders</div>
                <div style={styles.infoSubtitle}>Educators, Chancellors, and Directors</div>
              </div>
            </div>
          </div>

          {/* Summit Highlights */}
          <div style={styles.highlightsSection}>
            <h3 style={styles.highlightsTitle}>Summit Highlights</h3>
            <div style={styles.highlightsGrid}>
              {summitHighlights.map((highlight) => (
                <div key={highlight.id} style={styles.highlightItem}>
                  <div 
                    style={{
                      ...styles.highlightDot,
                      backgroundColor: highlight.color
                    }}
                  ></div>
                  <span style={styles.highlightText}>{highlight.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    padding: '60px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px'
  },
  comingSoonBadge: {
    display: 'inline-block',
    backgroundColor: '#E3F2FD',
    color: '#1976D2',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '16px'
  },
  title: {
    fontSize: '48px',
    fontWeight: '700',
    color: '#4A90E2',
    marginBottom: '16px',
    letterSpacing: '-0.02em'
  },
  subtitle: {
    fontSize: '18px',
    color: '#6b6b6b',
    lineHeight: '1.6',
    maxWidth: '600px',
    margin: '0 auto'
  },
  featuredCard: {
    background: 'linear-gradient(135deg, #4A90E2 0%, #A855F7 100%)',
    borderRadius: '20px',
    padding: '32px',
    marginBottom: '32px',
    position: 'relative',
    overflow: 'hidden'
  },
  featuredHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px'
  },
  calendarIcon: {
    fontSize: '24px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    padding: '8px',
    borderRadius: '8px'
  },
  featuredBadge: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    color: 'white',
    padding: '6px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  featuredContent: {
    color: 'white'
  },
  eventTitle: {
    fontSize: '32px',
    fontWeight: '700',
    marginBottom: '8px',
    margin: '0 0 8px 0'
  },
  eventSubtitle: {
    fontSize: '18px',
    opacity: '0.9',
    fontWeight: '400',
    margin: '0'
  },
  eventDetails: {
    backgroundColor: 'white',
    borderRadius: '16px',
    padding: '32px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
  },
  eventDescription: {
    fontSize: '16px',
    color: '#666',
    lineHeight: '1.6',
    marginBottom: '32px',
    margin: '0 0 32px 0'
  },
  eventInfoGrid: {
    display: 'grid',
    gap: '24px',
    marginBottom: '32px'
  },
  infoItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px'
  },
  infoIcon: {
    fontSize: '20px',
    padding: '8px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  infoTitle: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '4px'
  },
  infoSubtitle: {
    fontSize: '14px',
    color: '#666'
  },
  highlightsSection: {
    marginBottom: '32px'
  },
  highlightsTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '16px',
    margin: '0 0 16px 0'
  },
  highlightsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '12px'
  },
  highlightItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  highlightDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    flexShrink: 0
  },
  highlightText: {
    fontSize: '14px',
    color: '#666'
  },
  actionButtons: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap'
  },
  downloadButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: 'linear-gradient(45deg, #FFD54F, #FF8A65)',
    border: 'none',
    borderRadius: '12px',
    padding: '14px 24px',
    fontSize: '14px',
    fontWeight: '600',
    color: 'white',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit'
  },
  registerButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'transparent',
    border: '2px solid #ddd',
    borderRadius: '12px',
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontFamily: 'inherit'
  },
  buttonIcon: {
    fontSize: '16px'
  },
  buttonArrow: {
    fontSize: '16px',
    transition: 'transform 0.2s ease'
  }
};

// Add hover effects
const hoverStyles = `
  .download-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
  
  .register-btn:hover {
    border-color: #4A90E2;
    color: #4A90E2;
    transform: translateY(-2px);
  }
  
  .register-btn:hover .arrow {
    transform: translateX(4px);
  }
`;

// Inject hover styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = hoverStyles;
  document.head.appendChild(styleSheet);
}

export default UpcomingEvents;